module.exports = __webpack_public_path__ + "img/communityadminpainpoint2.a173b3aa.png";